var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevrageLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_23900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6673 13.3081C19.6673 16.5331 17.059 19.1414 13.834 19.1414L14.709 17.6831",
    stroke: "#526C7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 6.64144C1.33398 3.41644 3.94232 0.808105 7.16732 0.808105L6.29232 2.26644",
    stroke: "#526C7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 10.8911H8.35729C8.87396 10.8911 9.29896 11.3578 9.29896 11.8328C9.29896 12.3495 8.88229 12.7745 8.35729 12.7745H6.01562V10.8911Z",
    stroke: "#526C7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 12.7759H8.69896C9.29063 12.7759 9.77396 13.1925 9.77396 13.7175C9.77396 14.2342 9.29063 14.6592 8.69896 14.6592H6.01562V12.7759Z",
    stroke: "#526C7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 14.6509V15.5842",
    stroke: "#526C7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 9.9585V10.8918",
    stroke: "#526C7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8751 12.7735C12.8751 15.6152 10.5751 17.9152 7.73346 17.9152C4.8918 17.9152 2.5918 15.6152 2.5918 12.7735C2.5918 9.93187 4.8918 7.63184 7.73346 7.63184C7.8668 7.63184 7.9918 7.64019 8.13346 7.64852C10.6585 7.84019 12.6751 9.85685 12.8668 12.3818C12.8668 12.5068 12.8751 12.6319 12.8751 12.7735Z",
    stroke: "#526C7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4171 7.22417C18.4171 10.0658 16.1171 12.3659 13.2755 12.3659H12.8671C12.6755 9.84088 10.6588 7.82416 8.13379 7.6325V7.22417C8.13379 4.38251 10.4338 2.08252 13.2755 2.08252C16.1171 2.08252 18.4171 4.38251 18.4171 7.22417Z",
    stroke: "#526C7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_23900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevrageLight);
export default __webpack_public_path__ + "static/media/levrageLight.01b7aa24be600979f6969619444cc7b6.svg";
export { ForwardRef as ReactComponent };